import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { ConfigApp } from "../providers/config.app";
import { ToastService } from "../services/toast-service";
import { ServerService } from "../services/server-service";
import { HomePage } from '../pages/home/home';
// import { LoginPage } from '../pages/login/login';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpModule } from "@angular/http";
// import { AndroidPermissions } from '@ionic-native/android-permissions';
import { AppVersion } from '@ionic-native/app-version';
import { Network } from '@ionic-native/network';
// import { CalendarModule } from "ion2-calendar";
import { InAppBrowser } from '@ionic-native/in-app-browser';
// import { AppRate } from '@ionic-native/app-rate';
// import { SocialSharing } from '@ionic-native/social-sharing';
import { IonicSelectableModule } from 'ionic-selectable';
// import { NativeGeocoder} from '@ionic-native/native-geocoder';

// import { AngularFireModule } from 'angularfire2';
// import { AngularFireDatabaseModule } from 'angularfire2/database';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';

import { IonicImageViewerModule } from 'ionic-img-viewer';

import { LocalNotifications } from '@ionic-native/local-notifications';
import { Calendar } from '@ionic-native/calendar';


// get your credentials from Firebase Console
export const firebaseConfig = {
  apiKey: "AIzaSyAnemq1xC5ovFLeSbpc3TBqQ6DKBBEE-eA",
  authDomain: "activtec-7a96a.firebaseapp.com",
  projectId: "activtec-7a96a",
  storageBucket: "activtec-7a96a.appspot.com",
  messagingSenderId: "102588757895",
  appId: "1:102588757895:web:d81ac99644d72d66924522",
  measurementId: "G-6G5P03XZZP",
  databaseURL: "https://activtec-7a96a-default-rtdb.firebaseio.com/",
};


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    // LoginPage,
    // EventticketsPage,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    // CalendarModule,
    IonicImageViewerModule,
    IonicSelectableModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: 'חזרה',
      iconMode: 'ios',
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      tabsPlacement: 'bottom',
      pageTransition: 'ios-transition',
      monthNames: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
      monthShortNames: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
      dayNames: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
      dayShortNames: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'שבת'],
    }),
    // AngularFireModule.initializeApp(firebaseConfig),
    // AngularFireDatabaseModule,
    NgxSkeletonLoaderModule,
    Ng2GoogleChartsModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    // LoginPage,
    // EventticketsPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    ConfigApp,
    ToastService,
    ServerService,
    // BarcodeScanner,
    // AndroidPermissions,
    AppVersion,
    Network,
    InAppBrowser,
    LocalNotifications,
    Calendar,
    // AppRate,
    // SocialSharing,
    // NativeGeocoder,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts